/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClippInfo
 */
export interface ClippInfo {
    /**
     * 
     * @type {boolean}
     * @memberof ClippInfo
     */
    isEligible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClippInfo
     */
    createUrl?: string;
}

/**
 * Check if a given object implements the ClippInfo interface.
 */
export function instanceOfClippInfo(value: object): value is ClippInfo {
    return true;
}

export function ClippInfoFromJSON(json: any): ClippInfo {
    return ClippInfoFromJSONTyped(json, false);
}

export function ClippInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClippInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'isEligible': json['isEligible'] == null ? undefined : json['isEligible'],
        'createUrl': json['createUrl'] == null ? undefined : json['createUrl'],
    };
}

export function ClippInfoToJSON(json: any): ClippInfo {
    return ClippInfoToJSONTyped(json, false);
}

export function ClippInfoToJSONTyped(value?: ClippInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isEligible': value['isEligible'],
        'createUrl': value['createUrl'],
    };
}

